import TranscriptPage from "./TranscriptPage";

export default TranscriptPage;
